import { useResetSponsorshipVoucherFlow } from 'modules/auth/flows/useResetSponsorshipVoucherFlow'
import { useIsSponsorshipEnabled } from 'modules/auth/hooks/useIsSponsorshipEnabled'
import { useSignupStoreData } from 'modules/auth/store/useSignupStore'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import { AddSponsorshipVoucherButton } from './AddSponsorshipVoucherButton/AddSponsorshipVoucherButton'
import { SponsorshipVoucherPreview } from './SponsorshipVoucherPreview/SponsorshipVoucherPreview'
import { SponsorshipVoucherPreviewSkeleton } from './SponsorshipVoucherPreview/SponsorshipVoucherPreviewSkeleton'

interface Props {
  isPrePopulateSponsorshipVoucherLoading: boolean
}

export const SignupFormSponsorship = ({
  isPrePopulateSponsorshipVoucherLoading,
}: Props) => {
  const { t } = useTranslation('auth-components')
  const { publicSponsorshipVoucher } = useSignupStoreData()

  const { isSponsorshipEnabled } = useIsSponsorshipEnabled()

  const { resetSponsorshipVoucher } = useResetSponsorshipVoucherFlow()

  if (isPrePopulateSponsorshipVoucherLoading) {
    return <SponsorshipVoucherPreviewSkeleton />
  }

  if (!isSponsorshipEnabled) {
    return null
  }

  return (
    <div className="space-y-3">
      <h3>{t('signupForm.sponsorship.title')}</h3>
      {publicSponsorshipVoucher ? (
        <SponsorshipVoucherPreview
          publicSponsorshipVoucher={publicSponsorshipVoucher}
          onReset={resetSponsorshipVoucher}
        />
      ) : (
        <AddSponsorshipVoucherButton />
      )}
    </div>
  )
}
